<template lang="pug">
  .gvl-thank-you
    h2.text-center.py-4 Danke für Ihre Anfrage.<br>Wir prüfen Ihren Antrag und setzen uns anschließend mit Ihnen in Verbindung
    v-btn.mt-5(block color="primary" @click="onRouteToHome") zurück zur Startseite

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ]
})
export default class ThankYou extends Vue {
  onRouteToHome () {
    this.$store.dispatch('setToken', null)
    this.gotoRoute('home')
  }
}
</script>
